import React,{ useEffect, lazy, Suspense, useContext, useState }  from 'react';
import { Button, Modal } from 'react-bootstrap';
import SimpleContext from './../context/SimpleContext';
import './Buy.css';
import NumberFormat from 'react-number-format';
import BasketPreloader from './BAsketPreloader';
import config from './../../services/config.json';
import axios from 'axios';
import { saveAs } from "file-saver";


const FreshShoped = () => {
    const context = useContext(SimpleContext);

    const [SabtDialog, setSabtDialog] = useState(false);
    const [EtebarDialog, setEtebarDialog] = useState(false);
    const [Tamam, setTamam] = useState(false);
    const [EmptyDialog, setEmptyDialog] = useState(false);
    const [StockDialog, setStockDialog] = useState(false);
    const [ServerErrDialog, setServerErrDialog] = useState(false);
    const [minOrderDialogText, setminOrderDialogText] = useState(false);


    const BuyFresh_Varanegar_Discount = lazy(() => {
        return new Promise(resolve => setTimeout(resolve, 800))
        .then(
           () => import("./BuyFresh_Varanegar_Discount")
           );
        });
     
        // useEffect(() => {
            // context.Varanegar_Discountfresh();
        // }, [])

/****************************************************************Varanegar_Discount*************************************************************** */


    function Varanegar_Discount_Freshresponse() {

        let freshbothId = Date.now();

        let FreshSabadResponse = context.FreshSabadResponse.items;
        let FreshFactorInfo  = [];


        let No_Adad = 0;

        for (let k = 0; k < context.FRESHCartItems.length; k++) {
            for (let z = 0; z < FreshSabadResponse.length; z++) {
                if (parseInt(context.FRESHCartItems[k].goodsRef) === parseInt(FreshSabadResponse[z].goodsRef)) {
                    No_Adad = (context.FRESHCartItems[k].numSale * context.FRESHCartItems[k].ProCount)
                    FreshFactorInfo.push(
                        {
                            "CustomerBackOfficeID":`${context.UseInFo.backofficeID}`,
                            "addAmount":FreshSabadResponse[z].addAmount,
                            "Amount":FreshSabadResponse[z].amount,
                            "AmountNut":FreshSabadResponse[z].amountNut,
                            "Date": `${context.FullDate.Date}`,
                            "delivery_cost": 0.0,
                            "Discount": FreshSabadResponse[z].discount,
                            "mobile": context.UseInFo.mobile,
                            "No_Adad": (context.FRESHCartItems[k].numSale * context.FRESHCartItems[k].ProCount),
                            "paymentUsanceName": "نقد",
                            "supAmount": 0,
                            "tax": FreshSabadResponse[z].tax,
                            "Time": `${context.FullDate.time}`,
                            "BothID": freshbothId,
                            "charge": FreshSabadResponse[z].charge,
                            "orderType": 0,
                            "preorderID": 0,
                            "OrderLines":[
                                {
                                    "accYear": FreshSabadResponse[z].accYear,
                                    "addAmount": FreshSabadResponse[z].addAmount,
                                    "amount": FreshSabadResponse[z].amount,
                                    "amountNut": FreshSabadResponse[z].amountNut,
                                    "cPriceRef": FreshSabadResponse[z].custPrice,
                                    "charge": FreshSabadResponse[z].charge,
                                    "chargePercent": FreshSabadResponse[z].chargePercent,
                                    "custPrice": FreshSabadResponse[z].custPrice,
                                    "discount": FreshSabadResponse[z].discount,
                                    "evcItemAdd1": FreshSabadResponse[z].evcItemAdd1,
                                    "evcItemAdd2": FreshSabadResponse[z].evcItemAdd2,
                                    "evcItemAddOther": FreshSabadResponse[z].evcItemAddOther,
                                    "evcItemDis1": FreshSabadResponse[z].evcItemDis1,
                                    "evcItemDis2": FreshSabadResponse[z].evcItemDis2,
                                    "evcItemDis3": FreshSabadResponse[z].evcItemDis3,
                                    "evcItemDisOther": FreshSabadResponse[z].evcItemDisOther,
                                    "evcRef": FreshSabadResponse[z].evcRef,
                                    "goodsRef": FreshSabadResponse[z].goodsRef,
                                    "id": FreshSabadResponse[z].id,
                                    "NoInSale": context.FRESHCartItems[k].numSale,
                                    "NoOfCustSelection": context.FRESHCartItems[k].ProCount,
                                    "periodicDiscountRef": FreshSabadResponse[z].periodicDiscountRef,
                                    "prizeType": FreshSabadResponse[z].prizeType,
                                    "rowOrder": FreshSabadResponse[z].rowOrder,
                                    "supAmount": FreshSabadResponse[z].supAmount,
                                    "tax": FreshSabadResponse[z].tax,
                                    "taxPercent": FreshSabadResponse[z].taxPercent,
                                    "totalQty": FreshSabadResponse[z].totalQty,
                                    "unit": context.FRESHCartItems[k].unit,
                                    "unitCapasity": FreshSabadResponse[z].unitCapasity,
                                    "unitQty": FreshSabadResponse[z].unitQty,
                                    "unitRef": FreshSabadResponse[z].unitRef,
                                    "userPrice": FreshSabadResponse[z].userPrice
                                }
                            ]
                        }
                    )
                }
            }
        }


        let OrdLines = [];
        let TotalAmount = [];
        let TotalAmountNut = [];
        for (let k = 0; k < FreshFactorInfo.length; k++) {
           OrdLines.push(FreshFactorInfo[k].OrderLines[0])
           TotalAmount.push(FreshFactorInfo[k].Amount)
           TotalAmountNut.push(FreshFactorInfo[k].AmountNut)
        }
        
        let TotalAmountNum = 0;
        let TotalAmountNutNum = 0;
        for (let l = 0; l < TotalAmount.length; l++) {
            TotalAmountNum += TotalAmount[l]
        }
        for (let j = 0; j < TotalAmountNut.length; j++) {
            TotalAmountNutNum += TotalAmountNut[j]
        }

        let FinalFreshFactorInfo = [];
        FinalFreshFactorInfo.push(
            {
                "CustomerBackOfficeID":`${context.UseInFo.backofficeID}`,
                "addAmount":FreshFactorInfo[0].addAmount,
                "Amount":TotalAmountNum,
                "AmountNut":TotalAmountNutNum,
                "Date": `${context.FullDate.Date}`,
                "delivery_cost": 0.0,
                "Discount": FreshSabadResponse[0].discount,
                "mobile": context.UseInFo.mobile,
                "No_Adad": No_Adad,
                "paymentUsanceName": "نقد",
                "supAmount": 0,
                "tax": FreshFactorInfo[0].tax,
                "Time": `${context.FullDate.time}`,
                "BothID": freshbothId,
                "charge": FreshFactorInfo[0].charge,
                "orderType": 0,
                "preorderID": 0,
                "OrderLines":OrdLines
            }
        )
        return FinalFreshFactorInfo
    }



      function CheckFreshBasketMojudi () {
        let moreThanFreshStore = false;
        for (let i = 0; i < context.FRESHCartItems.length; i++) {
            for (let j = 0; j < context.varaanegar_stock.onHandQty.length; j++) {
                if (context.FRESHCartItems[i].uniqueid === context.varaanegar_stock.onHandQty[j].uniqueId) {
                    if ((context.FRESHCartItems[i].ProCount * context.FRESHCartItems[i].numSale) > context.varaanegar_stock.onHandQty[j].onHandQty) {               
                        moreThanFreshStore = true;
                        context.setStockProduct(context.FRESHCartItems[i].name)
                    }
                }
            }
        }
        return moreThanFreshStore;
    }


    const handlecallPostFunc = () => {
        async function FinalPost(){
            const url = `${config.InsertFreshOrder}`
            const param = {
            method : 'Post',
            body : JSON.stringify(Varanegar_Discount_Freshresponse())
            }
            const sendRequestSabt = await fetch(url , param)
            const responseSabt = await sendRequestSabt.json()
            return responseSabt
        }try{
            FinalPost()
              .then((res)=>{
   
                context.setFinalFreshResponse(res)
                setTamam(true)
              })
        }catch(ex) {
            console.log(ex);
        }
      }

    function Customer_FreshStatus_check () {
        setSabtDialog(false)
        if (context.UseInFo.status === 0) {
            setEtebarDialog(true)
        }else{
            if (CheckFreshBasketMojudi() === true) {
                setStockDialog(true)
            }else{
                handlecallPostFunc()
            }
        }
    }

    const StatusAndFreshSumPriceCheck = () => {
        if (context.FRESHCartItems.length>0) {
            context.FreshTTotalPrice < context.ApiSetting.minOrder? setminOrderDialogText(true): setSabtDialog(true)
        }else{
            setSabtDialog(true)
        }
    }
    let FreshButtonStyle ="ButtonDiv";
    context.FRESHCartItems.length === 0? FreshButtonStyle = "ButtonDiv_length0": FreshButtonStyle = "ButtonDiv";

    const handleShowFactor = () => {
        async function getData(){
          const url = 'https://apikala.com/api/downloadFactorUrl'
          const formData = new FormData();
          formData.append('factorID' , context.getFinalFreshResponse.OrderID);
        const param = {
          method : 'post', 
          body : formData
        }
   
          const sendRequest = await fetch(url , param)
          const response = await sendRequest.json()
          return response
          }
    
          try{
              getData()
              .then((data)=>{
              
                saveAs(
                  data.response.url
                );
              })
              
        }catch(ex) {
            console.log(ex);
        }
    
      }

    return ( 

        <div className="BuyMain">
            
            <div className="topNavDiv">
                <div className="FreshSabadAdiTopNav" onClick={()=> context.handleHistoryPush("/Buy")}>
                    <p className="p">سبد خرید کالاهای عادی</p>
                </div>
                <div className="FreshSabadFreshTopNav">
                    <p className="p">سبد خرید کالاهای فِرِش</p>
                </div>
            </div>

            <div className="ShopedProductDiv">
                <div className="BasketTitle">
                    <p className="p">کالاهای فِرِش</p>
                </div>

                <Suspense fallback={<BasketPreloader/>}>
                    <BuyFresh_Varanegar_Discount/>                
                </Suspense>                  
            </div>

            <div className={FreshButtonStyle}>
                <div className="FirstButton"><p>
                    مجموع سبد خرید شما:{" "}<NumberFormat value={context.FreshTTotalPrice} displayType={'text'} thousandSeparator={true} />{" "} ريال
                </p></div>
                <Button className="SecondButton" onClick={()=>StatusAndFreshSumPriceCheck()}>
                    ثبت نهایی خرید
                </Button>
            </div>



             {/* /*********************************************************تایید ثبت******************************************** */ }
            
             <Modal
            show={SabtDialog}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                    آیا از ثبت نهایی سبد خرید خود مطمئن هستید؟
                    </p>
                </Modal.Body>
                
                <Modal.Footer style={{padding:"3%", display:"flex", flexDirection:'row', justifyContent:"center"}}>
                    <Button variant="success" style={{width:"45%"}} onClick={()=> Customer_FreshStatus_check()}>بله</Button>
                    <Button variant="danger" style={{width:"45%"}} onClick={()=>setSabtDialog(false)}>خیر</Button>
                </Modal.Footer>
            </Modal>
            
    {/* /*********************************************************عدم تایید اعتبار******************************************** */ }
       
            <Modal
            show={EtebarDialog}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                    متاسفانه هنوز حساب کاربری شما تایید اعتبار نشده است.
                    <br/>
                    لطفا جهت تایید اعتبار باشماره 09120827616 تماس حاصل فرمایید.
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setEtebarDialog(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
            
    {/* /*********************************************************تایید ثبت******************************************** */ }
       
            <Modal
            show={Tamam}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                        سفارش شما دریافت شد.<br>
                        </br>
                        شما میتوانید فاکتور خرید خود را از قسمت سفارشات گذشته دانلود نمایید.
                        <br/>
                        زمان تحویل بار به شما:
                        <br/>
                        <p style={{color:"red"}}>
                        {context.DeliveryDateFresh.message}
                        </p>
                    </p>
                </Modal.Body>
                
                <Modal.Footer style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                    <Button variant="info" style={{width:"100%"}} onClick={()=>handleShowFactor()}>دانلود فاکتور</Button>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setTamam(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
            
    {/* /*********************************************************سبد خرید خالی******************************************** */ }
       
            <Modal
            show={EmptyDialog}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                        سبد خرید شما خالی میباشد!
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setEmptyDialog(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
            
    {/* /*********************************************************سبد خرید خالی******************************************** */ }
       
            <Modal
            show={StockDialog}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                        موجودی کالای {context.StockProduct} به اتمام رسیده است و یا کمتر از میزان انتخابی شما شده است.
                        <br/>
                        لطفا تعداد کالای انتخابی را کاهش داده و مجددا امتحان کنید.
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setStockDialog(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
    
    {/* /*********************************************************سبد خرید خالی******************************************** */ }
       
            <Modal
            show={ServerErrDialog}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                       خطایی در سرور رخ داده است.
                    </p><br/>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setServerErrDialog(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
    
    {/* /*********************************************************خرید کمتر از 100000******************************************** */ }
       
            <Modal
            show={minOrderDialogText}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                       {context.ApiSetting.minOrderDialogText}
                    </p><br/>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setminOrderDialogText(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
    
    

        </div>
    );
}
 
export default FreshShoped;